<template>
  <div class="collection-detail-container">
    <!-- <el-header>
      <div class="header-content">
        <el-button 
          icon="el-icon-back" 
          @click="goBack" 
          class="back-button"
        >
          Back
        </el-button>
        <h1>Course Details</h1>
      </div>
    </el-header> -->
    <el-main>
      <el-card class="collection-info-card" v-if="showPrivateAlert">
        <div class="private-alert">
          <i class="el-icon-lock"></i>
          <span>Sorry. This course is private and not visible to visitors.</span>
          <el-button type="primary" @click="$router.push('/')" plain>Back to Home</el-button>
        </div>
      </el-card>

      <el-card class="collection-info-card" v-if="!showPrivateAlert">
        <div v-if="loading" class="loading-container">
          <el-skeleton animated>
            <template>
              <div class="collection-header">
                <el-skeleton-item
                  variant="image"
                  style="width: 200px; height: 283px"
                />
                <div style="flex: 1">
                  <el-skeleton-item variant="h1" style="width: 50%" />
                  <el-skeleton-item
                    variant="text"
                    style="margin-top: 16px; width: 30%"
                  />
                  <el-skeleton-item variant="text" style="margin-top: 16px" />
                  <el-skeleton-item variant="text" style="margin-top: 16px" />
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>

        <div v-else style="width: 100%">
          <div class="collection-header">
            <div class="cover-image">
              <img
                v-if="collection.cover_url"
                :src="collection.cover_url"
                alt="Course Cover"
              />
              <div v-else class="placeholder-cover">
                <i class="el-icon-picture-outline"></i>
              </div>
            </div>
            <div class="collection-info">
              <div class="info-header">
                <h2>{{ collection.title }}</h2>
              </div>
              <p class="author">
                By
                <el-avatar
                  :size="24"
                  :src="collection.user_avatar_address_small"
                  :style="{
                    border: getBorderStyleByUserType(collection.user_type),
                    backgroundColor: collection.user_avatar_address_small && collection.user_avatar_address_small !== '' && collection.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                    fontSize: '14px',
                    color: '#409EFF',
                    marginRight: '4px',
                    verticalAlign: 'middle'
                  }"
                >
                  {{ collection.user_avatar_address_small && collection.user_avatar_address_small !== '' && collection.user_avatar_address_small !== 'undefined' ? '' : collection.user_name?.charAt(0) }}
                </el-avatar>
                <router-link
                  :to="'/profile?id=' + collection.user_id"
                  class="user-link"
                >{{ collection.user_name }}</router-link>
                |
                <span class="update-time"
                  >Latest update:
                  {{
                    new Date(
                      (collection.update_time || collection.create_time) * 1000
                    ).toLocaleDateString()
                  }}</span
                >

                <span class="version-identifier" v-if="collection.version_identifier && collection.version_identifier !== ''"
                  >| Version: {{ collection.version_identifier || 'v1.0' }}</span
                >
              </p>
              <div class="description" v-html="renderedDescription"></div>
              <div class="action-row">
                <div class="purchase-button-group">
                  <!-- Read Button (for subscribers) -->
                  <el-button
                    v-if="hasAccess && collection.user_id !== $store.state.user_id"
                    type="primary"
                    class="read-button"
                    @click="handleOverviewCollection"
                  >
                    Read
                  </el-button>
                  <!-- Subscribe Button (only when collection-level paywall blocks entry) -->
                  <el-button
                    v-if="collection.status === 'PUBLISHED' && collection.subscribers_only && !hasAccess && collection.user_id !== $store.state.user_id"
                    type="primary"
                    class="subscribe-button"
                    @click="$router.push('/platform-subscription')"
                  >
                    Subscribe for Full Access
                  </el-button>
                </div>
                <div class="edit-button-group" v-if="collection.user_id === $store.state.user_id">

                  <span>
                    <el-tag
                      :type="collection.status === 'PUBLISHED' ? 'success' : 'info'"
                      class="status-tag"
                    >
                      {{ collection.status === "PUBLISHED" ? "Published" : "Private" }}
                    </el-tag>
                  </span>
                  <el-button
                    v-if="hasAccess"
                    type="primary"
                    class="read-button"
                    @click="handleOverviewCollection"
                  >
                    Overview
                  </el-button>
                  <el-button type="primary" icon="el-icon-edit" @click="handleEdit">
                    Edit
                  </el-button>
                  <el-button class="share-button" icon="el-icon-share" @click="handleCommand('share')">
                    Share
                  </el-button>
                  <el-dropdown trigger="click" @command="handleCommand">
                    <el-button type="text">
                      <i class="el-icon-more"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        command="delete"
                        v-if="collection.user_id === $store.state.user_id"
                        class="delete-option"
                      >Delete this Course</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="edit-button-group" v-if="collection.user_id !== $store.state.user_id">
                  <el-button
                    :icon="isStarred ? 'el-icon-star-on' : 'el-icon-star-off'"
                    :loading="starLoading"
                    @click="toggleStar"
                    class="star-button"
                  >
                    {{ isStarred ? 'Starred' : 'Star' }}
                  </el-button>
                </div>
              </div>

            </div>
          </div>

          <div class="collection-stats">
            <div class="stats-row">
              <div class="stat-item">
                <i class="el-icon-folder"></i>
                <span>{{ collection.group_count || 0 }} Groups</span>
              </div>
              <div class="stat-item">
                <i class="el-icon-document"></i>
                <span>{{ collection.knowit_count || 0 }} Stacks</span>
              </div>
              <div class="stat-item">
                <i class="el-icon-document-copy"></i>
                <span>{{ collection.content_count || 0 }} Cards</span>
              </div>
              <div class="stat-item" v-if="collection.quiz_count && collection.quiz_count > 0">
                <i class="el-icon-question"></i>
                <span>{{ collection.quiz_count }} Quizzes</span>
              </div>
              <div class="stat-item" v-if="collection.word_count !== undefined && collection.word_count !== null">
                <i class="el-icon-edit-outline"></i>
                <span>{{ formatWordCount(collection.word_count) }} {{ collection.word_count === 1 ? 'Word' : 'Words' }}</span>
              </div>
            </div>
          </div>

          <div class="groups-container">
            <div class="groups-grid">
              <div
                v-for="(group, groupIndex) in collection.groups || []"
                :key="groupIndex"
                class="group-section"
              >
                <div class="group-content">
                  <div class="group-number-badge">{{ groupIndex + 1 }}</div>
                  <div class="group-info">
                    <h3>
                      {{ group.title }}
                      <el-tag v-if="group.subscribers_only" type="warning" size="mini" effect="plain" style="margin-left: 6px; vertical-align: middle;">
                        <i class="el-icon-lock"></i> Subscribers Only
                      </el-tag>
                    </h3>
                    <div class="group-badges">
                      <div class="knowit-count">
                        {{ (group.knowits || []).length }}
                        {{
                          (group.knowits || []).length === 1 ||
                          (group.knowits || []).length === 0
                            ? "Stack"
                            : "Stacks"
                        }}
                      </div>
                      <div
                        class="word-count-badge"
                        v-if="group.word_count !== undefined && group.word_count !== null"
                      >
                        {{ formatWordCount(group.word_count) }} {{ group.word_count === 1 ? 'Word' : 'Words' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!collection.groups?.length" class="no-data">
              <i class="el-icon-document"></i>
              <p>No Stacks in this course yet</p>
            </div>
          </div>
        </div>
      </el-card>
    </el-main>
  </div>
</template>

<script>
import Post from "@/components/Post.vue";
import { postRequest } from "@/apis/front";
import { marked } from "marked";
import DOMPurify from "dompurify";

export default {
  name: "CollectionDetail",
  components: {
    Post,
  },
  data() {
    return {
      loading: true,
      collection: {
        groups: [],
        title: "",
        description: "",
        user_name: "",
        views: 0,
        likes: 0,
        purchased: 0,
        price: 0,
        content_count: 0,
      },
      showPrivateAlert: false,
      isStarred: false,
      starLoading: false
    };
  },
  computed: {
    renderedDescription() {
      if (!this.collection.description) return "";
      marked.setOptions({ breaks: true, gfm: true });
      return DOMPurify.sanitize(marked(this.collection.description));
    },
    hasPlatformSubscription() {
      return this.$store.state.platformSubscription?.active ||
             this.collection.has_platform_subscription ||
             this.collection.order_info?.type === 'PLATFORM_SUBSCRIPTION';
    },
    hasAccess() {
      if (this.collection.user_id === this.$store.state.user_id) return true;
      // If collection-level paywall is set, require subscription
      if (this.collection.subscribers_only) return this.hasPlatformSubscription;
      // Otherwise, always allow entry (individual content may still be paywalled)
      return true;
    }
  },
  created() {
    this.fetchCollectionData();
    // Fetch platform subscription status if not already loaded
    if (!this.$store.state.platformSubscription) {
      this.$store.dispatch('fetchPlatformSubscription');
    }
  },
  beforeDestroy() {
  },
  methods: {
    formatWordCount(n) {
      const num = Number(n) || 0;
      if (num >= 1000) {
        return (num / 1000).toFixed(num >= 10000 ? 0 : 1).replace(/\.0$/, '') + 'k';
      }
      return num.toString();
    },
    async fetchCollectionData() {
      this.loading = true;
      const collectionId = this.$store.state.tempCollectionId || this.$route.query.id || this.$route.params.id;
      console.log('Deck ID:', collectionId)
      
      if (!collectionId) {
        this.$message.error('Course ID not found');
        this.$router.go(-1);
        return;
      }
      
      try {
        const response = await postRequest("getPostCollection", {
          id: collectionId,
          user_id: this.$store.state.user_id,
          detail_mode: 'SIMPLE'
        });

        if (response.data.code === 0) {
          const collectionData = response.data.data;
          const groupsWithCollapse = (collectionData.groups || []).map(
            (group) => ({
              ...group,
              isCollapsed: false,
            })
          );

          this.collection = {
            ...collectionData,
            groups: groupsWithCollapse,
            views: collectionData.views || 0,
            likes: collectionData.likes || 0,
            purchased: collectionData.purchased || 0,
          };

          // Fetch star status
          this.fetchStarStatus();
        }else if(response.data.code === -2){
          this.showPrivateAlert = true;
        } else {
          this.$message.error(response.data.msg || "Failed to load course");
        }
      } catch (error) {
        console.error("Error loading collection:", error);
        this.$message.error("Failed to load course");
      } finally {
        this.loading = false;
      }
    },
    async fetchStarStatus() {
      const collectionId = this.$store.state.tempCollectionId || this.$route.query.id || this.$route.params.id;
      try {
        const response = await postRequest("checkCollectionStarStatus", {
          user_id: this.$store.state.user_id,
          collection_id: collectionId
        });

        if (response.data.code === 0) {
          this.isStarred = response.data.data.is_starred;
        }
      } catch (error) {
        console.error("Error checking star status:", error);
      }
    },
    async toggleStar() {
      const collectionId = this.$store.state.tempCollectionId || this.$route.query.id || this.$route.params.id;
      this.starLoading = true;

      try {
        const endpoint = this.isStarred ? 'unstarCollection' : 'starCollection';
        const response = await postRequest(endpoint, {
          user_id: this.$store.state.user_id,
          collection_id: collectionId
        });

        if (response.data.code === 0) {
          this.isStarred = !this.isStarred;
          this.$message.success(this.isStarred ? 'Course starred!' : 'Course unstarred');
        } else {
          this.$message.error(response.data.msg || 'Operation failed');
        }
      } catch (error) {
        console.error("Error toggling star:", error);
        this.$message.error('Failed to update star status');
      } finally {
        this.starLoading = false;
      }
    },
    handleLike(postId) {
      console.log("Like post:", postId);
    },
    handleComment(postId) {
      console.log("Comment on post:", postId);
    },
    goBack() {
      this.$router.go(-1);
    },
    handleEdit() {
      const collectionId = this.$store.state.tempCollectionId || this.$route.query.id || this.$route.params.id;
      localStorage.setItem("editCollectionId", collectionId);
      this.$router
        .push({
          path: "/new-collection",
          query: { id: collectionId },
          replace: true,
        })
        .then(() => {
          window.location.reload();
        });
    },
    handleGetCollection() {
      const collectionId = this.$store.state.tempCollectionId || this.$route.query.id || this.$route.params.id;
      this.$router.push({
        path: "/collection-order",
        query: {
          collection_id: collectionId,
        },
      });
    },
    handleCommand(command) {
      if (command === "share") {
        const collectionId = this.$store.state.tempCollectionId || this.$route.query.id || this.$route.params.id;
        const url = 'https://learningfirst.io/collection/' + collectionId;
        navigator.clipboard
          .writeText(url)
          .then(() => {
            this.$message.success("Link copied to clipboard!");
          })
          .catch(() => {
            this.$message.error("Failed to copy link");
          });
      } else if (command === "delete") {
        this.$confirm(
          "Are you sure you want to delete this course? This action cannot be undone.",
          "Warning",
          {
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            type: "warning",
            customClass: "delete-confirm",
            confirmButtonClass: "el-button--danger",
          }
        )
          .then(async () => {
            try {
              const collectionId = this.$store.state.tempCollectionId || this.$route.query.id || this.$route.params.id;
              const response = await postRequest("deletePostCollection", {
                collection_id: collectionId,
                user_id: this.$store.state.user_id,
              });

              if (response.data.code === 0) {
                this.$message.success("Course deleted successfully");
                this.$router.go(-1);
              } else {
                this.$message.error(
                  response.data.msg || "Failed to delete course"
                );
              }
            } catch (error) {
              console.error("Error deleting collection:", error);
              this.$message.error("Failed to delete course");
            }
          })
          .catch(() => {
            this.$message.info("Delete cancelled");
          });
      }
    },
    handleOverviewCollection() {
      const collectionId = this.$store.state.tempCollectionId || this.$route.query.id || this.$route.params.id;
      this.$store.dispatch('setTempCollectionId', collectionId)
      this.$router.push({
        path: '/read-collection',
        query: {
          id: collectionId,
          collection_id: collectionId
        }
      });
    },
    getBorderStyleByUserType(userType) {
      // Default to Individual if not set
      const type = userType || 'individual';
      
      switch(type) {
        case 'individual':
          return '1px solid #1890ff'; // Theme blue border
        case 'institution':
          return '1px solid #67C23A'; // Green border for institutions
        case 'agent':
          return '1px solid #E6A23C'; // Orange border for agents
        default:
          return '1px solid #e0e0e0'; // Default gray border
      }
    }
  },
};
</script>

<style>
/* .el-container,
.el-header,
.el-main,
.el-card,
.el-card__body {
  width: 100%;
  max-width: 1200px !important;
  margin: 0 auto !important;
} */


</style>

<style scoped>
.collection-detail-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
}

:deep(.el-card__body) {
  padding: 20px !important;
}

.el-header {
  background-color: #409eff;
  color: white;
  padding: 20px;
}

.el-main {
  padding: 20px;
}

.collection-info-card {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.private-alert {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 16px;
  text-align: center;
}

.private-alert i {
  font-size: 48px;
  color: #909399;
}

.private-alert span {
  font-size: 16px;
  color: #606266;
}

.private-alert .el-button {
  margin-top: 8px;
}

.collection-header {
  position: relative;
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  padding: 0 40px;
}

.collection-info {
  flex: 1;
  position: relative;
  padding-right: 20px;
  min-width: 0;
}

.collection-info h2 {
  margin: 0 0 10px 0;
}

.author {
  color: #909399;
  margin: 0 0 10px 0;
}

.description {
  color: #303133;
  line-height: 1.6;
  margin-top: 16px;
}

.collection-stats {
  padding: 20px 0;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 30px;
}

.stats-row {
  display: flex;
  gap: 20px;
  flex-wrap: nowrap;
  margin-bottom: 8px;
}

.stats-row:last-child {
  margin-bottom: 0;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  white-space: nowrap;
}

.groups-container {
  margin-top: 30px;
}

.groups-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 30px;
  width: 95%;
  padding: 0 10px;
  box-sizing: border-box;
}

.group-section {
  background: white;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
  width: 100%;
  box-sizing: border-box;
}

.group-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.group-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.group-number-badge {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
}

.group-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.group-info h3 {
  margin: 0;
  color: #409eff;
  font-size: 18px;
  line-height: 1.4;
  word-break: break-word;
}

.knowit-count {
  color: #409eff;
  background-color: #ecf5ff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  display: inline-block;
  align-self: flex-start;
  white-space: nowrap;
  border: 1px solid #409eff;
}

.group-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.word-count-badge {
  color: #67c23a;
  background-color: #f0f9eb;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  display: inline-block;
  align-self: flex-start;
  white-space: nowrap;
  border: 1px solid #b3e19d;
}

.back-button {
  position: absolute;
  left: 0;
  color: white;
  border: 1px solid white;
  background: transparent;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-color: white;
}

h1 {
  flex: 1;
  text-align: center;
  margin: 0;
  position: relative;
  padding: 0 40px;
}

.action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 0;
  flex-wrap: wrap;
}

.purchase-button-group {
  display: flex;
  align-items: center;
  gap: 16px;
}


.subscribe-button {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  border: none;
}

.subscribe-button:hover {
  background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
}

.buy-individual-link {
  color: #909399;
  font-size: 13px;
}

.edit-button-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.token-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
}


.get-collection-button {
  margin-top: 0;
}

.user-link {
  color: #409eff;
  text-decoration: none;
}

.user-link:hover {
  text-decoration: underline;
}

.delete-option {
  color: #f56c6c !important;
}

.delete-option:hover {
  background-color: #fef0f0 !important;
}

/* Override Element UI's confirmation dialog for delete action */
:deep(.el-message-box.delete-confirm) {
  .el-message-box__title {
    color: #f56c6c;
  }

  .el-button--primary {
    background-color: #f56c6c;
    border-color: #f56c6c;
  }
}

.cover-image {
  width: 200px;
  height: 283px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #f5f7fa;
}

.cover-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.placeholder-cover {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #909399;
}

.placeholder-cover i {
  font-size: 48px;
}

.share-button {
  background-color: #ecf5ff;
  border-color: #409eff;
  color: #409eff;
}

.share-button:hover {
  background-color: #409eff;
  border-color: #409eff;
  color: white;
}

.share-button:focus {
  background-color: #ecf5ff;
  border-color: #409eff;
  color: #409eff;
}

.read-button {
  /* Removing the absolute positioning styles */
}


.star-button {
  color: #f7ba2a;
  border-color: #f7ba2a;
}

.star-button:hover {
  color: #ffffff;
  background-color: #f7ba2a;
  border-color: #f7ba2a;
}

.star-button.is-loading {
  color: #f7ba2a;
}
</style> 